import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import NumericStepper from '@vtex/styleguide/lib/NumericStepper'

import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import ProductAvailabilityInfo from '../ProductAvailabilityInfo'

const MIN_BUY_VALUE = 1

function QuantitySelector({
  onChangeAmount,
  amount,
  inStoreQuantity,
  hasDeliveryStock,
  hasPickUpStock,
  isLoadingStock,
  isSimulationLoading,
  handleRefresh,
  hasSimulationError,
  isItemAvailable,
  skuId,
}) {
  const [fakeLoading, setFakeLoading] = useState(false)
  const { cartMaxSkuQuantity } = getInstoreConfig()
  const fakeLoad = () => {
    setFakeLoading(true)
    setTimeout(() => setFakeLoading(false), 150)
  }

  const onChangeHandler = (...params) => {
    onChangeAmount(...params)
    fakeLoad()
  }

  useEffect(() => {
    fakeLoad()
  }, [skuId])

  const cartMaxSkuQuantityNumber = parseInt(cartMaxSkuQuantity, 10)
  const maxValue = isNaN(cartMaxSkuQuantityNumber)
    ? null
    : cartMaxSkuQuantityNumber
  const shouldHideNumericStepper = !isItemAvailable

  return (
    <div className="w-100 flex flex-row justify-between items-center pa5 b--muted-4 ba br2 flex-wrap">
      <div>
        <ProductAvailabilityInfo
          isLoadingInStoreStock={isLoadingStock || fakeLoading}
          isLoadingSimulationStock={isSimulationLoading || fakeLoading}
          inStoreQuantity={inStoreQuantity}
          hasDeliveryStock={hasDeliveryStock}
          hasPickUpStock={hasPickUpStock}
          hasSimulationError={hasSimulationError}
          handleRefresh={handleRefresh}
        />
      </div>
      <div
        className={`${shouldHideNumericStepper ? 'v-hidden' : ''}`}
        id="quantity-selector-container"
      >
        <NumericStepper
          lean
          minValue={MIN_BUY_VALUE}
          maxValue={maxValue}
          value={amount}
          onChange={onChangeHandler}
          size="regular"
        />
      </div>
    </div>
  )
}

QuantitySelector.defaultProps = {
  inStoreQuantity: 0,
  minValue: 1,
}

QuantitySelector.propTypes = {
  onChangeAmount: PropTypes.func.isRequired,
  amount: PropTypes.number.isRequired,
  inStoreQuantity: PropTypes.number,
  hasDeliveryStock: PropTypes.bool,
  hasPickUpStock: PropTypes.bool,
  isLoadingStock: PropTypes.bool,
  isSimulationLoading: PropTypes.bool,
  hasSimulationError: PropTypes.bool,
  handleRefresh: PropTypes.func.isRequired,
  isItemAvailable: PropTypes.bool,
  mediaQuery: PropTypes.func.isRequired,
  skuId: PropTypes.string.isRequired,
}

export default QuantitySelector
